import { Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'vectronic-formly-elastic-belts-dialog-content',
  imports: [MatIcon],
  template: `
    <div class="container">
      <div class="alert alert-info">
        <p>
          VECTRONIC collars can be supplied with a wide range of elastic and growing belt variants.
          The materials used are characterized by high durability. VECTRONIC uses only
          weather-resistant outdoor materials to create a long-lasting product. All the belt
          variants presented have already been used successfully by our customers for many years.
        </p>
        <p>
          Elastic and growing belts are specially designed for the requirements of young animals and
          animals with strong seasonal fluctuations of the neck circumference, such as male deer.
        </p>
        <p>
          VECTRONIC is known for incorporating customer ideas into its products. Product requests
          can be discussed. Since a new product development takes time, the regular production times
          must be extended.
        </p>
        <p>
          The color of the belt covers for elastic and growing belts is picked according to stock.
        </p>
      </div>
      @for (section of data(); track section.label) {
        <section>
          <div class="label">
            <h2>{{ section.label }}</h2>
            @if (section.favorite) {
              <span><mat-icon>star</mat-icon>VECTRONIC customers favorite</span>
            }
          </div>
          <p>{{ section.description }}</p>
          <div class="element-list">
            @for (element of section.elements; track element.label) {
              <div class="element">
                <h3>{{ element.label }}</h3>
                <div class="images">
                  @for (image of element.images; track image.url) {
                    <img [src]="image.url" [alt]="image.alt" />
                  }
                </div>
              </div>
            }
          </div>
        </section>
      }
    </div>
  `,
  styles: [
    `
      @use 'variables';
      .container {
        padding: 1.5rem 0.5rem;
        display: flex;
        flex-direction: column;
        gap: 2rem;
      }
      .alert {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;

        p {
          font-size: 1rem;
          line-height: 1.25rem;
          margin: 0;
        }
      }
      .label {
        display: flex;
        place-items: center;
        margin-bottom: 1rem;
        gap: 0.5rem;

        span {
          background-color: variables.$vectronic-orange;
          color: white;
          font-size: 12px;
          border-radius: 16px;
          display: inline-block;
          font-weight: bold;
          display: flex;
          place-items: end;
          gap: 0.25rem;
          padding: 0.25rem 0.5rem;

          mat-icon {
            font-size: 1rem;
            height: 1rem;
            width: 1rem;
          }
        }
      }
      h2,
      h3 {
        color: variables.$vectronic-secondary;
      }
      p,
      h3 {
        margin-bottom: 1rem;
      }
      h2 {
        font-size: 1.25rem;
      }
      h3 {
        font-size: 1rem;
      }
      p {
        font-size: 1.125rem;
        line-height: 1.5;
      }
      img {
        width: 200px;
      }
      .element-list {
        display: flex;
        flex-wrap: wrap;
        gap: 1.25rem;
      }
      .element {
        flex: 1;
        border: 1px solid #e2e8f0;
        border-radius: 8px;
        padding: 1rem;
        text-align: center;
      }
      .images {
        display: flex;
        justify-content: center;
      }
    `,
  ],
})
export class ElasticBeltsDialogContentComponent {
  data = input.required<
    {
      label: string;
      favorite: boolean;
      description: string;
      elements: {
        label: string;
        images: {
          url: string;
          alt: string;
        }[];
      }[];
    }[]
  >();
}
